/**
 * What each Help-Us-Improve-shaped survey promised its responders (feature 105).
 *
 * The Survey Responses tab lists two surveys with the same questions — the original
 * (`help_us_improve`, 3 months) and the 30-days survey (`help_us_improve_30_days`). A grant
 * made for a response must carry THAT survey's push wording (`source`) and open on its
 * promised length (`defaultDays`), so both are read per row from here. An unknown code falls
 * back to the original survey — the screen's behaviour before 105.
 */
export const SURVEY_REWARDS = {
  help_us_improve: { source: 'help_us_improve', promise: 'three months of Premium' },
  help_us_improve_30_days: { source: 'help_us_improve_30_days', promise: '30 days of Premium', defaultDays: 30 },
};

export const surveyReward = (code) => SURVEY_REWARDS[code] || SURVEY_REWARDS.help_us_improve;
